export interface ResolutionProperty {
    width: number;
    height: number;
}

export const stringifyResolutionProperty = (res: ResolutionProperty): string => `${res.width} x ${res.height}`;
